import { createSelector } from '@reduxjs/toolkit';

export const selectData = (state) => state.chat.data;
export const selectError = (state) => state.chat.error;
export const selectLoading = (state) => state.chat.loading;
export const selectCountOfUnread = (state) => state.chat.countOfUnread;
export const selectSearchVisible = (state) => state.chat.searchVisible;
export const selectCurrentMessage = (state) => state.chat.currentMessage;

export const selectUserId = createSelector([selectData], (data) => {
  return data.userId;
});

export const selectAccessToken = createSelector([selectData], (data) => {
  return data.accessToken;
});

export const selectChannelUrl = createSelector([selectData], (data) => {
  return data.channelUrl;
});
